module.exports = __webpack_public_path__ + "static/media/Turnip.90d2b447.png";